import type { SVGProps } from "react";

export const ExportDoneIllustration = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="200"
      height="200"
      fill="none"
      viewBox="0 0 200 200"
      {...props}
    >
      <defs>
        <path
          id="sparkle"
          d="M0 -28 L2.8 -10.5 C4.9 2.1 13.9 11.1 26.5 13.2 L44 16 L26.5 18.8 C13.9 20.9 4.9 29.9 2.8 42.5 L0 55 L-2.8 42.5 C-4.9 29.9 -13.9 20.9 -26.5 18.8 L-44 16 L-26.5 13.2 C-13.9 11.1 -4.9 2.1 -2.8 -10.5 Z"
          fill="#C8E6FA"
        />
      </defs>

      {/* 2 large — left and right */}
      <use href="#sparkle" transform="translate(26, 70) scale(0.65)" />
      <use href="#sparkle" transform="translate(170, 100) scale(0.65)" />

      {/* 2 small — top-right and bottom-left */}
      <use href="#sparkle" transform="translate(148, 42) scale(0.38)" />
      <use href="#sparkle" transform="translate(52, 148) scale(0.38)" />
    </svg>
  );
};
